import { render, staticRenderFns } from "./wdjb.vue?vue&type=template&id=c842249a&scoped=true"
import script from "./wdjb.vue?vue&type=script&lang=js"
export * from "./wdjb.vue?vue&type=script&lang=js"
import style0 from "./wdjb.vue?vue&type=style&index=0&id=c842249a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c842249a",
  null
  
)

export default component.exports